module.exports = __webpack_public_path__ + "fonts/pONg1hwwL_6M9EkZySr_yteUu13KDQ.703bd64c.woff2";